import React from 'react'
import styled from 'styled-components'
import { motion, AnimatePresence } from 'framer-motion'

const Overlay = ({ id, top = "0", left = "0", bottom = "0", right = "0", bg = "var(--overlay-color)", pad = "48px", children, variant, handleClick, motion, bottomAlign, clearBackground }) => {

  // console.log(bottomAlign)

  return (


    <Wrap $bg={bg} $clearBackground={clearBackground} onClick={handleClick} {...motion} id={id} $top={top} $bottom={bottom} $left={left} $bottomAlign={bottomAlign} $right={right} $pad={pad} >{children}</Wrap>

  )
}

// 

export default Overlay


const Wrap = styled(motion.div)`
  position: absolute;
  padding: 10px 10px 50px 10px;
  z-index: 500;
  right: ${(props) => (props.$right)};
  left: ${(props) => (props.$left)};
  bottom: ${(props) => (props.$bottom)};
  top: ${(props) => (props.$top)};
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: ${(props) => (props.$bottomAlign ? "end" : "center")};       
  background-color: ${(props) => (props.$clearBackground ? "transparent" : props.$bg)};        
  pointer-events: ${(props) => (props.$clearBackground ? "none" : "auto")};        
  
  
  
  @media(width > 768px) {
      padding: ${(props) => (props.$pad)};
  }
`